import { PcSpWidth } from './Constant'

export const BreakPoint = {
  SMARTPHONE_MAX_WIDTH: `${PcSpWidth.SMARTPHONE_MAX_WIDTH}px`,
  TABLET_MIN_WIDTH: `${PcSpWidth.TABLET_MIN_WIDTH}px`,
  TABLET_MAX_WIDTH: `${PcSpWidth.TABLET_MAX_WIDTH}px`,
  // ↑わかりにくいので↓に変えていきたい
  MOBILE: `${PcSpWidth.MOBILE}px`,
  MOBILE_L: `${PcSpWidth.MOBILE_L}px`,
  TABLET: `${PcSpWidth.TABLET}px`,
  LAPTOP: `${PcSpWidth.LAPTOP}px`,
  LAPTOP_L: `${PcSpWidth.LAPTOP_L}px`
}

/**
 * @deprecated Styles.color.primary[400]を使ってください
 */
export const CommmuneTextBlue = '#254860'

export const Styles = {
  color: {
    primary: {
      400: '#254860',
      300: '#728fa4',
      200: '#eef7fb'
    },
    secondary: {
      400: '#ef5e4b'
    },
    grayscale: {
      400: '#333',
      300: '#757575',
      200: '#e8ecee',
      100: '#fff'
    },
    border: {
      400: '#ced8dc'
    }
  },
  spacing: {
    1: '1px',
    2: '2px',
    3: '4px',
    4: '6px',
    5: '8px',
    6: '12px',
    7: '16px',
    8: '20px',
    9: '24px',
    10: '32px',
    11: '48px',
    12: '64px',
    13: '80px',
    14: '96px'
  },
  fontSize: {
    // 主に見出しで使うサイズ
    900: '50px',
    800: '40px',
    700: '31px',
    600: '21px',
    500: '18px',
    // 主に本文で使うサイズ
    400: '16px',
    300: '14px',
    200: '12px',
    100: '10px'
  },
  fontWeight: {
    bold: '700',
    semiBold: '500',
    normal: '400'
  },
  lineHeight: {
    400: '1.7',
    300: '1.5',
    200: '1.3'
  },
  letterSpacing: {
    400: '0.06em'
  },
  borderRadius: {
    1: '6px',
    4: '32px'
  }
}
